export default __webpack_public_path__ + "static/media/gallery-wip-pommel-cap_03.f30e4739.jpg";